import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileTextAreaInputControlView{

    constructor() { }

    afterRender(control){
        mobileAdjustment.adjustMobileControl(control);
    }
}

const mobileTextAreaInputControlView = new MobileTextAreaInputControlView();
export default mobileTextAreaInputControlView;